// Shared styles used in tours index
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Grid } from 'views/anyguide/messages/styles';
import SearchThinIcon from 'views/ui/icons/search-thin-icon';
import { Theme } from 'ui_system/theme';

const { isIE } = window.mobileDetect;
const { isEdge } = window.mobileDetect;
const isMobile = !!window.mobileDetect.mobile();

export { Theme, isIE, isMobile, isEdge };

export const FormView = styled('div')`
  position: relative;
  @media (max-width: ${Theme.mobile.phoneWidth - 1}px) {
    display: ${(props) => (props.mobileTabsMenuToggled ? 'none' : 'block')};
    margin-bottom: 60px;
  }
`;

export const EditorContainer = styled(Grid)`
  height: 100vh;
  @media (max-width: ${Theme.mobile.phoneWidth - 1}px) {
    grid-template-columns: 100%;
  }
`;

export const LoadingOverlay = styled('div')`
  height: 100vh;
  width: 100vw;
  background: #fff;
  opacity: 0.5;
  position: fixed;
  z-index: 2;
`;

export const SquarePhoto = styled('img')`
  width: ${(props) => props.size};
  margin-right: 5px;
`;

export const Notice = styled('div')`
  background: ${(props) =>
    props.type === 'error'
      ? Theme.colors.errorRedColorDark
      : props.brandColor
        ? props.brandColor
        : Theme.colors.toastColor};
  color: ${Theme.colors.primaryTextColor};
  display: flex;
  align-items: center;
  align-self: center;
  font-family: 'soleil', sans-serif;
  font-size: 1.4rem;
  font-weight: ${Theme.fontWeight.regular};
  height: ${(props) => (props.show ? '60px' : '0')};
  left: 0;
  line-height: 1.8;
  overflow: hidden;
  justify-content: center;
  position: relative;
  right: 0;
  top: 0;
  transition: height 200ms ease-in-out;
  z-index: 100;
  @media (max-width: ${Theme.mobile.phoneWidth - 1}px) {
    font-size: 1.3rem;
    padding-left: 10px;
    line-height: 1.7;
  }
  @media (max-width: ${Theme.mobile.mobileBreakpointWidth - 1}px) {
    font-size: 1.3rem;
    padding-left: 10px;
    line-height: 1.7;
  }
`;

export const ResourceInfo = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
`;

export const AvatarContainer = styled('div')`
  margin: 0px 15px 0px 0px;
`;

const searchIconStyle = css`
  margin: auto;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 15px;
  color: ${Theme.colors.line};
  font-size: 16px;
`;

export const Search = styled('div')`
  position: relative;
  width: 100%;
  margin-top: 20px;
  i {
    ${searchIconStyle};
    cursor: pointer;
  }
`;
export const SearchIcon = styled(SearchThinIcon)`
  ${searchIconStyle}
`;

export const SearchInput = styled('input')`
  width: 100%;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 10px;
  padding-right: 10px;
  box-sizing: border-box;
  border: 1px solid ${Theme.colors.inputs.border};
  border-radius: 0px;
  font-size: 14px;
  background: white;

  ::-webkit-input-placeholder {
    /* Chrome/Opera/Safari */
    color: ${Theme.colors.inputs.placeholder};
  }
  ::-moz-placeholder {
    /* Firefox 19+ */
    color: ${Theme.colors.inputs.placeholder};
  }
  :-ms-input-placeholder {
    /* IE 10+ */
    color: ${Theme.colors.inputs.placeholder};
  }
  :-moz-placeholder {
    /* Firefox 18- */
    color: ${Theme.colors.inputs.placeholder};
  }
`;

export const Resource = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 15px;
  cursor: ${(props) => (props.disabled ? 'default' : 'pointer')};
  border-bottom: ${(props) => (props.last ? '0px' : '1px')} solid
    ${Theme.colors.dividerInactionableFieldColor};
  background-color: ${(props) =>
    props.selected ? Theme.colors.selectionBlue : 'default'};

  /* Checkmark */
  i {
    color: ${Theme.colors.linksDesignElementsBaseColor};
    visibility: ${(props) => (props.selected ? 'visible' : 'hidden')};
    font-size: 16px;
  }
`;
